import React, { useEffect, useState } from 'react';
import { Slide } from 'react-reveal';
import PopularCourseCartAimation from '../../../PowerFullAnimation/PopularCourseCartAimation';
import JobPreperationCart from './JobPreperationCart';

const JobPreperation = () => {

    const [course, setCourse] = useState([]);
    const [loaddig, setLoaddig] = useState(true);



    useEffect(() => {
        fetch('https://one0m-backend2.onrender.com/job/all')
            .then(res => res.json())
            .then(data => {
                setCourse(data?.getJob);
                setLoaddig(false);
            })
            .catch(err => {
                setLoaddig(true)
            })
    }, [course])


    return (
        <div className="container-fluid p-5" style={{ borderRadius: "10px" }}>
            <div className="course-title text-center mt-5 mb-5">
                <div className="popular-title">
                    <Slide right>
                        <h3 className="fw-bold mb-2 fs-2">চাকরি পরীক্ষা প্রস্তুতি</h3>
                        <h5 className="fs-4">আপনি কোন চাকরির জন্য প্রস্তুতি নিচ্ছেন?</h5>
                    </Slide>
                </div>

            </div>
            <div className="course-data">
                <div className="row gy-4">
                    {
                        course.map(course => <JobPreperationCart course={course} key={course._id} />)
                    }
                </div>
            </div>
            <div className="isLoading">
                {
                    loaddig ? <>

                        <PopularCourseCartAimation />

                    </>


                        : ""
                }
            </div>
        </div>
    );
};

export default JobPreperation;